export const TABS_LOCALE = {
    more: 'more',
};
